<template>
  <div v-if="visible" class="custom-tooltip" :style="{ left: position.x + 'px', top: position.y + 'px' }">
    {{ content }}
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      content: '',
      position: { x: 0, y: 0 }
    };
  },
  methods: {
    showTooltip(event, content) {
      this.content = content;
      this.position.x = event.pageX + 10; // Desplazamiento para no tapar el cursor
      this.position.y = event.pageY + 10;
      this.visible = true;
    },
    hideTooltip() {
      //this.visible = false;
    }
  }
};
</script>

<style scoped>
.custom-tooltip {
  position: absolute;
  background-color: black;
  color: white;
  padding: 5px;
  border-radius: 4px;
  font-size: 12px;
  z-index: 9999;
}
</style>